import { createAsyncThunk } from '@reduxjs/toolkit';
import { iStateMessage } from '@/customTypes/GenericReduxTypes';
import { iGenericResponse } from '@/customTypes/CommonServiceTypes';
import { curryGetThunkName } from '@/projectUtils/ReduxUtil';
import { resellerSubscriptionUrl } from '@/services/api/cresivoxServer';
import { REDUCER_NAME } from './Types';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addResellerPlane = createAsyncThunk<
  iGenericResponse<any>,
  { vendorId: string; planId: string },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName('addResellerPlane'),
  async ({ vendorId, planId }, { rejectWithValue }) => {
    try {
      const response = await resellerSubscriptionUrl.addResellerPlane({
        vendorId,
        planId,
      });

      // ✅ SUCCESS
      if (response?.httpStatusCode === 200) {
        return response;
      }

      // ❌ API FAILURE
      return rejectWithValue({
        httpStatusCode: response?.httpStatusCode ?? 400,
        message:
          response?.responseBody?.error ?? 'Assign plan failed',
      });
    } catch (error: any) {
      return rejectWithValue({
        httpStatusCode: 500,
        message: error?.message || 'Unexpected error occurred',
      });
    }
  }
);


// httpStatusCode

  export const getResellerSubscriptionList = createAsyncThunk<
  iGenericResponse<any>,
  { search?: string } | void,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("getResellerSubscriptionList"),
  
  // @ts-expect-error
  async ({search}, { rejectWithValue }) => {
    try {
      
      const response = await resellerSubscriptionUrl.getResellerSubscriptionList(search);

      // console.log("this is reseller subscription data List",response)
      if (response?.httpStatusCode === 200) {
        return {
          httpStatusCode: response.httpStatusCode,
          data: response.data.data,
          message: response.message,
        };
      }

      return rejectWithValue({
        httpStatusCode: response.httpStatusCode,
        message: response.message,
      });
    } catch (error: any) {
      return rejectWithValue({
        message: error?.message || "Something went wrong",
      });
    }
  }
);
